import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fd6b386"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "page-toolbar-approval__icon",
  "aria-hidden": "true"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Phê duyệt", -1))
const _hoisted_3 = {
  class: "page-toolbar-approval__dropdown",
  role: "menu",
  "aria-label": "Phê duyệt"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "page-toolbar-approval-slot",
  class: "page-toolbar-approval__dropdown-body"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]

import { onBeforeUnmount, onMounted, ref } from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faCheckDouble,
  faChevronDown,
} from "@fortawesome/free-solid-svg-icons";
import { usePageToolbar } from "@/core/hooks/usePageToolbar";


export default /*#__PURE__*/_defineComponent({
  __name: 'PageToolbarApprovalDropdown',
  setup(__props) {

const { pageToolbar, approvalOpen, actionsOpen, filtersOpen } =
  usePageToolbar();
const rootRef = ref<HTMLElement | null>(null);

function toggleApproval() {
  const next = !approvalOpen.value;
  approvalOpen.value = next;
  if (next) {
    filtersOpen.value = false;
    actionsOpen.value = false;
  }
}

function onDocumentClick(event: MouseEvent) {
  if (!approvalOpen.value || !rootRef.value) {
    return;
  }
  const target = event.target as Node | null;
  if (target && !rootRef.value.contains(target)) {
    approvalOpen.value = false;
  }
}

onMounted(() => {
  document.addEventListener("click", onDocumentClick, true);
});

onBeforeUnmount(() => {
  document.removeEventListener("click", onDocumentClick, true);
});

return (_ctx: any,_cache: any) => {
  return (_unref(pageToolbar).showApproval)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "page-toolbar-approval",
        ref_key: "rootRef",
        ref: rootRef
      }, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["page-toolbar-approval__btn", { 'page-toolbar-approval__btn--open': _unref(approvalOpen) }]),
          onClick: toggleApproval
        }, [
          _createElementVNode("span", _hoisted_1, [
            _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faCheckDouble) }, null, 8, ["icon"])
          ]),
          _hoisted_2,
          _createVNode(_unref(FontAwesomeIcon), {
            icon: _unref(faChevronDown),
            class: _normalizeClass(["page-toolbar-approval__chevron", { 'page-toolbar-approval__chevron--open': _unref(approvalOpen) }])
          }, null, 8, ["icon", "class"])
        ], 2),
        _withDirectives(_createElementVNode("div", _hoisted_3, _hoisted_5, 512), [
          [_vShow, _unref(approvalOpen)]
        ])
      ], 512))
    : _createCommentVNode("", true)
}
}

})